// extracted by mini-css-extract-plugin
module.exports = {"btn-color":"BizGoodsDataViewDefInfoInteraction_btn-color__2SYUj","btn-root":"BizGoodsDataViewDefInfoInteraction_btn-root__1d_GB"};